module.exports = __webpack_public_path__ + "static/media/lekarz.e4936e1a.svg";